"use client";

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../defaultTheme";
import Circle from "../icons/Circle";
import handleKeyDown from "../utils/handleKeyDown";
import { defaultFocus } from "../utils/common";
const StyledSwitch = styled.label.withConfig({
  displayName: "Switch__StyledSwitch",
  componentId: "sc-1ip27uw-0"
})(["display:inline-block;"]);
const StyledSwitchBase = styled.div.withConfig({
  displayName: "Switch__StyledSwitchBase",
  componentId: "sc-1ip27uw-1"
})(["", ";"], ({
  theme,
  checked,
  disabled
}) => css(["display:flex;align-items:center;justify-content:space-between;cursor:", ";width:40px;height:20px;background-color:", ";border-radius:100px;position:relative;transition:background-color ", ";opacity:", ";", ";"], !disabled && "pointer", theme.orbit.backgroundSwitch, theme.orbit.durationFast, disabled && "0.5", checked && css(["background-color:", ";"], theme.orbit.backgroundSwitchChecked)));
const StyledSwitchButton = styled.div.withConfig({
  displayName: "Switch__StyledSwitchButton",
  componentId: "sc-1ip27uw-2"
})(["", ";"], ({
  theme,
  checked,
  hasCustomIcon,
  disabled
}) => css(["box-sizing:border-box;display:inline-flex;align-items:center;justify-content:center;position:absolute;left:-3px;width:24px;height:24px;border-radius:", ";background:", ";transition:", ";box-shadow:inset 0 0 1px 0 rgba(7,64,92,0.1),", ";&:active{box-shadow:", ";}svg{height:12px;width:12px;color:", ";}", ";"], theme.orbit.borderRadiusCircle, theme.orbit.paletteWhite, theme.orbit.durationFast, theme.orbit.boxShadowAction, !disabled && theme.orbit.boxShadowActionActive, hasCustomIcon ? theme.orbit.paletteInkNormal : theme.orbit.backgroundSwitch, checked && css(["left:calc(100% + 2px);transform:translateX(-100%);svg{color:", ";}"], theme.orbit.backgroundSwitchChecked)));
const StyledSwitchInput = styled.input.withConfig({
  displayName: "Switch__StyledSwitchInput",
  componentId: "sc-1ip27uw-3"
})(["cursor:inherit;position:absolute;opacity:0;width:100%;height:100%;top:0;left:0;margin:0;padding:0;&:focus + ", "{", ";}"], StyledSwitchButton, defaultFocus);
StyledSwitchInput.defaultProps = {
  theme: defaultTheme
};
StyledSwitchBase.defaultProps = {
  theme: defaultTheme
};
StyledSwitchButton.defaultProps = {
  theme: defaultTheme
};
const Switch = /*#__PURE__*/React.forwardRef(({
  onChange,
  checked,
  dataTest,
  id,
  icon,
  onBlur,
  onFocus,
  disabled,
  ariaLabelledby
}, ref) => {
  return /*#__PURE__*/React.createElement(StyledSwitch, null, /*#__PURE__*/React.createElement(StyledSwitchBase, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(StyledSwitchInput, {
    ref: ref,
    checked: checked,
    disabled: disabled,
    "aria-checked": checked,
    role: "switch",
    "aria-labelledby": ariaLabelledby,
    onKeyDown: !disabled ? handleKeyDown(undefined, onChange) : undefined,
    onBlur: !disabled ? onBlur : undefined,
    onChange: !disabled ? onChange : undefined,
    onFocus: !disabled ? onFocus : undefined,
    type: "checkbox",
    "data-test": dataTest,
    id: id
  }), /*#__PURE__*/React.createElement(StyledSwitchButton, {
    checked: checked,
    disabled: disabled,
    hasCustomIcon: !!icon
  }, icon || /*#__PURE__*/React.createElement(Circle, null))));
});
Switch.displayName = "Switch";
export default Switch;